<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1"/>
        <b-breadcrumb :items="items_eng" v-else-if="thai_student==0"/>
        <b-breadcrumb  v-else/>
      </div>

      <b-row>
        <b-col sm="6">
          <create-bio-part7  ></create-bio-part7>
        </b-col>
        <b-col sm="6">
          <b-card v-if="thai_student==0" header-class="redmfu">
            <div slot="header">
              <strong>Instruction: Graduates’ Self-Assessment of Future Skills
              </strong>
            </div>

            &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbspPlease self-assess your skills acquired through the teaching and learning of Mae Fah Luang University by choosing self-assessment scale of each skill.
           
<!--            <br> Your responses to the survey will help MFU improves the effectiveness-->
<!--            <br> of its teaching and student development.-->


          </b-card>
          <b-card v-else-if="thai_student==1" header-class="redmfu">
            <div slot="header">
              <strong>คำชี้แจง : แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต <br>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp  </strong>
            </div>
            &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbspบัณฑิตโปรดประเมินทักษะของตนเองที่ได้รับจากการจัดการเรียนการสอนของมหาวิทยาลัย โดยให้คะแนนตามคำชี้แจงขอค่าคะแนนการประเมินตนเอง (การเลือกระดับคะแนน 1 -5 หมายถึง บัณฑิตมีทักษะครบตามระดับคะแนนในแต่ละข้อ)
<!--            <br>คะแนน แบ่งเป็น 5 ระดับ เรียงลำดับจากมากไปน้อย ดังนี้  <br>-->

          </b-card>
          <b-card v-else>

          </b-card>
        </b-col>
      </b-row>
      <create-part10></create-part10>
    </div>
  </div>
</template>

<script>
import CreatePart10 from "../../components/CreatePart10.vue";
import CreateBioPart7 from "../../components/CreateBioPart7.vue";

export default {
  components: {
    CreatePart10,
    CreateBioPart7
  },
  name: "Part10",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/main"
        },
        {
          text: "แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/main"
        },
        {
          text: "Graduates’ Self-Assessment of Future Skills",
          href: "#"
        }
      ],
      part7:1,
      categorey: []
    };
  },
  methods: {},
  mounted() {
  },
  created() {
    if ( (this.$store.state.user !=null) && (this.$store.state.user !=undefined) && (this.$store.state.user !='')) {
      this.thai_student = this.$store.state.user.thaistudent;
    }else{
      console.log("x",this.$store.state.use)
      this.$router.push("/login");
    }
  }
};
</script>
<style>

</style>
